/**
 * APCWO customisation for OrangeHRM — Personal Review module.
 *
 * Licensed under the GNU General Public License v2.0 or later, the same terms
 * as OrangeHRM itself. See the LICENSE file at the project root.
 */

import {urlFor} from '@ohrm/core/util/helper/url';

export const API_BASE = '/api/v2/apcwo/personal-review';

export const STATUS_LABELS = {
  not_started: 'Not started',
  draft: 'Draft',
  submitted: 'Submitted',
  completed: 'Completed',
};

export const downloadUrl = (reviewId, scope, format) =>
  urlFor('/personalReview/download/{id}/{scope}/{format}', {
    id: reviewId,
    scope,
    format,
  });

export const errorMessage = (e) =>
  (e && e.response && e.response.data && e.response.data.error
    ? e.response.data.error.message
    : null) || 'Something went wrong. Please try again.';

export const formatDate = (value) => {
  if (!value) return '';
  const date = new Date(`${String(value).slice(0, 10)}T00:00:00`);
  if (Number.isNaN(date.getTime())) return value;
  return date.toLocaleDateString(undefined, {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};
